import { render, staticRenderFns } from "./OrderSummery.vue?vue&type=template&id=5efa8f48&scoped=true"
import script from "./OrderSummery.vue?vue&type=script&lang=js"
export * from "./OrderSummery.vue?vue&type=script&lang=js"
import style0 from "./OrderSummery.vue?vue&type=style&index=0&id=5efa8f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efa8f48",
  null
  
)

export default component.exports